import React from 'react';
import { Button, Checkbox, InputNumber } from 'antd';

/** 地图设置：显示天数 / 自动清理 / 位置数据清理（叠加相关已迁至「叠加图层 → 图层设置」） */
export function buildMapSettingsTab(context) {
  const {
    shouldShowPage,
    mapSettings,
    setMapSettings,
    handleSaveMapSettings,
    handleCleanupLocationData,
    mapSettingsMsg
  } = context;
  if (!shouldShowPage('地图设置')) return null;

  return {
    key: 'map_settings',
    label: '地图设置',
    children: (
      <MapSettingsPanel
        mapSettings={mapSettings}
        setMapSettings={setMapSettings}
        handleSaveMapSettings={handleSaveMapSettings}
        handleCleanupLocationData={handleCleanupLocationData}
        mapSettingsMsg={mapSettingsMsg}
      />
    )
  };
}

function MapSettingsPanel({
  mapSettings,
  setMapSettings,
  handleSaveMapSettings,
  handleCleanupLocationData,
  mapSettingsMsg
}) {
  return (
    <div>
      <h3>地图设置</h3>
      <p style={{ color: '#666', fontSize: 13, marginBottom: 16 }}>
        路网/等高线点击飞行、全景地图挂点请到「叠加图层 → 图层设置」配置。
      </p>
      <div style={{ marginBottom: 16 }}>
        <Button type="primary" onClick={handleSaveMapSettings}>保存设置</Button>
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
        <div>
          <h4>地图显示天数</h4>
          <InputNumber
            value={mapSettings.map_display_days}
            onChange={(value) => setMapSettings((prev) => ({ ...prev, map_display_days: value }))}
            min={1}
            max={365}
          />
        </div>
        <div>
          <h4>自动清理</h4>
          <Checkbox
            checked={mapSettings.map_auto_cleanup}
            onChange={(e) => setMapSettings((prev) => ({ ...prev, map_auto_cleanup: e.target.checked }))}
          >
            启用自动清理
          </Checkbox>
        </div>
      </div>
      <div style={{ marginTop: 16 }}>
        <h4>数据清理</h4>
        <Button
          danger
          onClick={() => handleCleanupLocationData(30)}
          style={{ marginRight: 8 }}
        >
          清理30天前数据
        </Button>
        <Button
          danger
          onClick={() => handleCleanupLocationData(7)}
        >
          清理7天前数据
        </Button>
      </div>
      {mapSettingsMsg && (
        <div style={{ color: mapSettingsMsg.includes('成功') ? 'green' : 'red', marginTop: 16 }}>
          {mapSettingsMsg}
        </div>
      )}
    </div>
  );
}
